import { Application } from "@hotwired/stimulus";
import { ModalController } from './modal-controller';
import axios from '@/modules/axios/index';

class AgreementModalController extends ModalController {
  connect() {
    this.openModal();
  }

  submit() {
    axios.put(`/api/v1/customer/agreements`)
      .then(() => this.closeModal())
      .catch(() => this.closeModal());
  }
}

// Registered in customer.js
export { AgreementModalController };